import {gql} from "@apollo/client";

export const POST_JOB_SETTINGS = gql`
	mutation postJobSettings ($input: PostJobSettingsInput!) {
		postJobSettings (input: $input) {
			jobSettings {
				id
			}
		}
	}
`;
